/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/scenario-mapper/scenario-mapper',['require','jquery','underscore','plugins/chatmapper-tree/chatmapper-tree','core/engine','core/layouts/fade-region','core/base-screen','screens/scenario-mapper/scenario','screens/scenario-mapper/scenario-location','screens/scenario-mapper/scenario-utils','screens/scenario-mapper/scenario-dialog','screens/scenario-mapper/scenario-mapper-radial-menu','screens/scenario-mapper/scenario-mapper-radial-item'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');

  var ChatmapperTree = require('plugins/chatmapper-tree/chatmapper-tree');
  //var Modernizr = require('modernizr');

  var Engine = require('core/engine');
  var FadeRegion = require('core/layouts/fade-region');

  var BaseScreen = require('core/base-screen');
  var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioLocation = require('screens/scenario-mapper/scenario-location');
  var ScenarioUtils = require('screens/scenario-mapper/scenario-utils');
  var ScenarioDialog = require('screens/scenario-mapper/scenario-dialog');

  var RadialMenu = require('screens/scenario-mapper/scenario-mapper-radial-menu');
  var RadialItem = require('screens/scenario-mapper/scenario-mapper-radial-item');

  /*****************************************************************************************************************///}

  var ScenarioMapper = BaseScreen.extend({

    events: {
      //'click [data-mc=skip_mc]': 'onSkipClickHandler',
      //'click [data-mc=info_mc]': 'onInfoClickHandler'
    },

    regions: {
      activityHolder: {
        selector: '#activity-container',
        regionClass: FadeRegion
      }
    },

    rawJson: null,
    scenario: null,

    overlayMC: null,
    overlayFailMC: null,
    bgContainer: null,
    radialContainer: null,
    chatContainer: null,
    activityContainer: null,
    blockerMC: null,
    skipBtn: null,
    infoBtn: null,
    activitySkipBtn: null,

    lastConversation: null,
    activeConversation: null,

    activeRadial: null,
    activeChat: null,
    activeActivity: null,
    activeLocation: null,

    forceBlocker: false,

    lastClickMC: null,

    meterPercMC: null,
    meterBarMC: null,
    meterLimitsMC: null,

    showMeter: true,
    hideHelp: false,

    feedbackActive: false,

    ambientSC: null,
    scenarioReplay: false,
    moduleReplay: false,
    loaderTO: null,

    noNext: true,
    helpOpened: false,

    isFirstModule: false,
    skippable: true,

    //feedbackScroll: null,

  /////////////
  // METHODS /{
  /////////////

    initialize: function()
    {
      BaseScreen.prototype.initialize.apply(this, arguments);

      this.isFirstModule = Engine.module('Paging').firstModule().get('id') === this.page.collection.parent.get('id');
      ////console.log('SCENARIO MAPPER:');
      ////console.log(this);
      ////console.log(this.model.get('maxPoints'));
    },

    onRender: function()
    {
      this.bgContainer = this.$el.find('[data-mc=background_mc]');
      this.radialContainer = this.$el.find('[data-mc=radial_mc]');
      this.chatContainer = this.$el.find('[data-mc=chat_mc]');
      this.activityContainer = this.$el.find('[data-mc=activity_mc]');//.addClass('hw-accel');
      this.blockerMC = this.$el.find('[data-mc=blocker_mc]');
      this.overlayMC = this.$el.find('[data-mc=overlay_mc]');
      this.overlayFailMC = this.$el.find('[data-mc=overlay_fail_mc]');
      this.scenarioLoader = this.$el.find('[data-mc=scenario-loader]');
      this.activityLoader = this.$el.find('[data-mc=activity-loader]');

      this.hideOverlay();
      this.hideAudioProgress();

      this.skipBtn = this.$el.find('[data-mc=skip_mc]');
      this.activitySkipBtn = this.$el.find('[data-mc=activity_skip_mc]').hide();

      this.meterMC = this.$el.find('[data-mc=meter_mc]');
      this.meterPercMC = this.$el.find('[data-mc=perc_mc]');
      this.meterBarMC = this.$el.find('[data-mc=bar_mc]');
      this.meterLimitsMC = this.$el.find('[data-mc=limits_mc]');

      this.introContainer = this.$el.find('[data-mc=intro_mc]');
      this.introTitleMC = this.introContainer.find('[data-mc=intro_title]');
      this.introSceneMC = this.introContainer.find('[data-mc=intro_scene]');
      this.introTextMC = this.introContainer.find('[data-mc=intro_text]');

      this.beginBtn = this.$el.find('[data-mc=intro_start_btn]').addClass('disabled').hide();
      this.loadBtn = this.$el.find('[data-mc=intro_start_btn_loading]').show();
      this.introHelpBtn = this.$el.find('[data-mc=intro_help_btn]');

    },

    onShow: function()
    {
      ////console.log('ON SHOW');
      this.setupIntro();
      this.updateLoader(0);
      this.hideActivityLoader();
      require(['json!content/' + this.model.get('scenario-data') + '?rand=' + Math.round(Math.random() * 1000).toString()], $.proxy(this.chatDataLoadedCallback, this), $.proxy(this.chatDataFailCallback, this));
      //this.playAmbientAudio();
      /*if (this.model.get('media'))
        this.playMedia();
      else
        this.finish();*/
    },

    setupIntro: function()
    {
      console.log('setup intro!!!!');
      this.helpOpened = false;

      $('#genome .genome-viewport').addClass('hide-captions');
      var pageTitle = this.page.collection.parent.get('title');

      if (this.isFirstModule)
      {
        console.log('is first mod');
        pageTitle = this.model.get('global').globalText.tutorialPrefix + ' ' + pageTitle;
        this.radio.on('scenario.overlay.closing', _.bind(this.visIntro, this));
        this.onHelpPressHandler();
        this.visIntro(true);
      }

      var $h1 = $('<h1>').html(pageTitle);
      this.introTitleMC.append($h1);
      var $img = $('<img>');
      $img.attr('src', 'content/graphics/mission_scene_' + this.page.collection.parent.get('id') + '.png');
      this.introSceneMC.append($img);
      this.introTextMC.html(this.model.get('introText'));

      //if (Engine.module('Paging').firstModule().seen() || this.helpOpened || this.page.collection.parent.seen())
      if (!this.isFirstModule)
      {
        this.introHelpBtn.on('click', _.bind(this.onHelpPressHandler, this));
      }
      else
      {
        this.$el.addClass('first-time-viewing');
        this.$el.find('.intro-help').hide();
      }
    },

    visIntro: function(_hide)
    {
      _hide = _hide === undefined ? false : _hide;
      if (_hide)
        this.introContainer.hide();
      else
        this.introContainer.show();
    },

    hideIntro: function()
    {
      $('#genome .genome-viewport').removeClass('hide-captions');
      this.beginBtn.off('click');
      this.introHelpBtn.off('click');
      this.introContainer.hide();
    },

    onHelpPressHandler: function(evt)
    {
      this.helpOpened = true;
      this.radio.trigger('ui.button.pressed.help');
    },

    setInterface: function()
    {
      ////console.log('BaseScreen::setInterface');

      var ui = { help: true, badge: false, caption: true };

      // standard ui settings
      if (!this.page.get('autonomous'))
      {
        ui.home = true;
        ui.back = false;
        ui.next = false;
      }

      // custom ui settings
      _.assign(ui, this.page.get('ui'));

      this.radio.trigger('ui.update', ui);
    },

    chatDataLoadedCallback: function(data)
    {
      ////console.log('chatMapper data loaded');
      this.ready(data);
    },

    chatDataFailCallback: function(err)
    {
      _.delay($.proxy(function() {
        require(['json!content/' + this.model.get('scenario-data') + '?rand=' + Math.round(Math.random() * 1000).toString()], $.proxy(this.chatDataLoadedCallback, this), $.proxy(this.chatDataFailCallbackFinal, this));
      }, this), 500);
      console.error('chatMapper data failed');
      console.error(err);
    },

    chatDataFailCallbackFinal: function(err)
    {
      alert('There was an error loading the mission. Please press menu and try again.');
      console.error('chatMapper data failed Final');
      console.error(err);
    },

    modelChanged: function()
    {
      ////console.log('changing');
    },

    onMediaEnded: function(e)
    {
      BaseScreen.prototype.onMediaEnded.apply(this, arguments);
      console.warn('scenario-mapper::onMediaEnded');
      //this.finish();
    },

    ready: function(data)
    {
      var rulesObj = this.model.get('scenario-rules');
      this.showMeter = true;// always show meter now per enhancements - (rulesObj.showMeter === undefined) ? true : rulesObj.showMeter;
      this.hideHelp = (rulesObj.hideHelp === undefined) ? false : rulesObj.hideHelp;

      //this.scenarioReplay = (this.page.collection.parent.get('maxPoints') !== 0);
      //console.log('scenario ready', this.page, this.page.get('maxPoints'));
      this.scenarioReplay = (this.page.get('maxPoints') >= 2);
      this.moduleReplay = this.page.collection.parent.seen();

      if (this.skipBtn)
      {
        //console.warn('settings', Engine.module('settings'));
        if (Engine.module('Cheats').settings.allowSkip)
        {
          this.skipBtn.show();
          this.skipBtn.on('click', $.proxy(this.onSkipClickHandler, this));
        }
        else
        {
          this.skipBtn.hide();
        }
        //this.skipBtn.hide(); TODO
      }

      if (data)
      {
        this.scenario = new Scenario(data);
        this.addScenarioListeners();
      }

      if (!this.showMeter && !this.scenarioReplay)
      {
        this.meterMC.hide();
      }

      if (this.scenarioReplay)
        this.$el.addClass('scenario-replay');

      if (this.moduleReplay)
        this.$el.addClass('module-replay');

      this.hideFeedbackBlocker();

      // if page.maxPoints > 0 show the audio cheat

      //super.ready(); wait to call this until scenario data is ready
    },

    pause: function()
    {
      // call super instead? TODO
      if (this.scenario && this.scenario.activeDialog)
      {
        this.scenario.activeDialog.pause();
      }
    },

    resume: function()
    {
      // call super instead? TODO
      if (this.scenario && this.scenario.activeDialog)
      {
        this.scenario.activeDialog.resume();
      }
    },

    onScenarioReadyHandler: function(evt)
    {
      this.hideLoader();
      this.addFirstConvoBG();
      this.initialHotspotSetup();
      Scenario.updateItemFrames();
      this.off(Scenario.SCENARIO_READY);
      this.scenario.off(Scenario.SCENARIO_READY, this.onScenarioReadyHandler);

      //this.scenario.begin();
      this.hideLoader();

      this.beginBtn.on('click', _.bind(this.onStartScenarioHandler, this));
      this.beginBtn.removeClass('disabled');
      this.beginBtn.show();
      this.loadBtn.hide();
    },

    onStartScenarioHandler: function(evt)
    {
      // remove the auto tutorial concept per client request
      if (!this.scenario)
        return;

      this.beginScenario();
      return;

      /*if (Engine.module('Paging').firstModule().seen() || this.helpOpened || this.page.collection.parent.seen())
      {
        this.beginScenario();
      }
      else
      {
        this.radio.on('scenario.overlay.closing', _.bind(this.beginScenario, this));
        this.onHelpPressHandler();
      }*/
    },

    beginScenario: function()
    {
      this.radio.off('scenario.overlay.closing');
      this.scenario.begin();
      this.hideIntro();
    },

    hideLoader: function()
    {
      clearTimeout(this.loaderTO);
      this.scenarioLoader.delay(250).fadeOut();
    },

    updateLoader: function(_val)
    {
      var _perc = Math.round(_val * 100);
      ////console.log('update loader', _perc);
      this.scenarioLoader.find('.loader-percent').html(_perc + '%');
      this.scenarioLoader.attr('data-loaded', _perc);
      clearTimeout(this.loaderTO);
      this.loaderTO = setTimeout($.proxy(this.loaderSlow, this), 10000);
    },

    showActivityLoader: function()
    {
      ////console.log('show actloader');
      this.updateActivityLoader(0);
      this.actInt = setTimeout($.proxy(function() {
        this.activityLoader.fadeIn();
      }, this), 750);
    },

    updateActivityLoader: function(_val)
    {
      var _perc = Math.round(_val * 100);
      //console.log('update activity loader', _perc);
      this.activityLoader.find('.loader-percent').html(_perc + '%');
      this.activityLoader.attr('data-loaded', _perc);
      clearTimeout(this.loaderTO);
      this.loaderTO = setTimeout($.proxy(this.loaderSlow, this), 10000);
    },

    hideActivityLoader: function()
    {
      //console.log('hide actloader', this.activityLoader);
      clearTimeout(this.loaderTO);
      clearTimeout(this.actInt);
      this.activityLoader.fadeOut();
    },

    loaderSlow: function()
    {
      this.radio.trigger('slow.connection');
    },

    addFirstConvoBG: function()
    {
      var bg = this.scenario.firstConversation.bg;
      this.bgContainer.append(bg);
    },

    addScenarioListeners: function()
    {
      this.scenario.on(Scenario.SCENARIO_READY, $.proxy(this.onScenarioReadyHandler, this));
      this.scenario.on(Scenario.SCENARIO_COMPLETE, $.proxy(this.onScenarioCompleteHandler, this));

      this.scenario.on(Scenario.SHOW_CONVERSATION, $.proxy(this.onShowConversationHandler, this));
      this.scenario.on(Scenario.SHOW_DIALOG, $.proxy(this.onShowDialogHandler, this));

      this.scenario.on(Scenario.FEEDBACK_STARTED, $.proxy(this.onFeedbackStartHandler, this));
      this.scenario.on(Scenario.FEEDBACK_COMPLETE, $.proxy(this.onFeedbackCompleteHandler, this));
      this.scenario.on(Scenario.UPDATE_FEEDBACK_PROGRESS, $.proxy(this.onFeedbackProgressHandler, this));

      this.scenario.on(Scenario.SHOW_BLOCKER, $.proxy(this.onShowBlockerHandler, this));
      this.scenario.on(Scenario.HIDE_BLOCKER, $.proxy(this.onHideBlockerHandler, this));

      this.scenario.on(Scenario.UPDATE_POINTS, $.proxy(this.onUpdatePointsHandler, this));
      this.scenario.on(Scenario.UPDATE_LOADING, $.proxy(this.updateLoader, this));
      this.scenario.on(Scenario.UPDATE_ACTIVITY_LOADING, $.proxy(this.updateActivityLoader, this));

      if (this.blockerMC && this.scenarioReplay)
      {
        //this.blockerMC.on('click', $.proxy(this.blockerClickHandler, this));
      }

      //$(document).on(Scenario.SKIP_MAPPER_AUDIO, $.proxy(this.onSkipAudioHandler, this));
    },

    onFeedbackStartHandler: function($dialog)
    {
      this.feedbackActive = true;

      if (this.blockerMC)
      {
        if (this.moduleReplay)
        {
          this.blockerMC.find('[data-mc=skip_audio_mc]').show();
          this.blockerMC.find('[data-mc=skip_audio_mc]').off('click');
          this.blockerMC.find('[data-mc=skip_audio_mc]').on('click', $.proxy(this.onSkipClickHandler, this));
        }
        else
        {
          this.blockerMC.off('click');
          this.blockerMC.on('click', $.proxy(this.blockerClickHandler, this));
        }
      }

      if (ChatmapperTree && ChatmapperTree.tree)
      {
        ChatmapperTree.updateByID($dialog.nlID);
      }
      this.showFeedbackBlocker();
      return false;
    },

    onFeedbackCompleteHandler: function(evt)
    {
      this.feedbackActive = false;

      if (this.blockerMC)
      {
        this.blockerMC.find('[data-mc=skip_audio_mc]').off('click');
        this.blockerMC.off('click');
        this.blockerMC.find('[data-mc=skip_audio_mc]').hide();
      }

      if (this.scenario.ended)
      {
        this.showFailOverlay();
      }
      else
      {
        this.hideFeedbackBlocker();
      }
      return false;
    },

    onFeedbackProgressHandler: function(evt, data)
    {
      this.updateFeedbackProgress(data);
      return false;
    },

    updateFeedbackProgress: function($feedbackObj)
    {
      if (this.blockerMC && this.blockerMC.find('[data-mc=audio_mc]').length > 0)
      {
        this.blockerMC.find('[data-mc=audio_mc]').attr('data-perc', Math.round($feedbackObj.timePerc * 100));
      }
    },

    onShowBlockerHandler: function(evt)
    {
      this.forceBlocker = true;
      this.showFeedbackBlocker();
    },

    onHideBlockerHandler: function(evt)
    {
      this.forceBlocker = false;
      this.hideFeedbackBlocker();
    },

    onUpdatePointsHandler: function(evt)
    {
      this.calculatePoints();
      var $minPoints = Scenario.getVariableValueByName('minPoints') || -100;
      var $maxPoints = this.page.get('maxPoints');
      var $curPoints = this.page.get('earnedPoints');
      var $perc = ($curPoints >= 0) ? $curPoints / $maxPoints : $curPoints / Math.abs($minPoints);

      var $posX = (this.meterLimitsMC.width() / 2 * $perc) + (this.meterLimitsMC.width() / 2) + this.meterLimitsMC.position().left;
      ////console.log('posX: ' + $posX);
      $posX = ($curPoints >= 0) ? Math.min($posX, this.meterLimitsMC.width() + this.meterLimitsMC.position().left - this.meterBarMC.width()) : Math.max($posX, this.meterLimitsMC.position().left);
      ////console.log('posX: ' + $posX);

      /*if (CourseSettings.singleton.cheats)
      {
        _meterPercMC.perc_tf.text = Math.floor($perc * 100) + '%';
      }
      Tweener.removeTweens(_meterBarMC);
      Tweener.addTween(_meterBarMC, { time:1, x:$posX } );*/
      console.warn('updateponts', this.meterBarMC, this.meterLimitsMC, $posX, $curPoints, $perc);
      console.warn(this);
      this.meterBarMC.stop().animate({left: $posX}, 1000);

      if ($curPoints <= $minPoints)
      {
        this.scenario.ended = true;
      }
    },

    showInfoOverlay: function()
    {
      this.trigger('LOAD_PAGE_AS_OVERLAY_BY_ID', 'scenario_info');
    },

    showFailOverlay: function()
    {
      //console.log('fail overlay');
      this.scenario.failed = true;
      this.radio.trigger('ui.update', {help: false});
      this.showFeedbackBlocker();
      this.finish();
      //this.showFinishOverlay();
      this.setupFeedback(this.model.get('feedback')['final-fail-feedback'], true, true);
    },

    showFinishOverlay: function()
    {
      //console.log('finish overlay');
      var $feedbackStr;
      var $specificArr;
      var $specificFeedbackObj;
      var $sContent;
      var $showReplay = false;
      var $failed = false;

      this.radio.trigger('ui.update', {home: false});

      this.showFeedbackBlocker();
      if (this.page.get('earnedPoints') / this.page.get('maxPoints') >= this.page.collection.parent.get('percBronze') || !this.model.get('feedback')['final-specific-feedback'])
      {
        $feedbackStr = this.model.get('feedback')['final-pass-feedback'];
      }
      else
      {
        $feedbackStr = this.model.get('feedback')['final-specific-feedback'];
        // $failed = true; removed so to bypass the failed overlay

        $specificFeedbackObj = this.model.get('feedback')['specific-feedback'];
        if ($specificFeedbackObj)
        {
          $specificArr = Scenario.getFeedbackVars();
          $feedbackStr = $feedbackStr.concat('<ul>');
          _.each($specificArr, function($sVar) {
            if ($sVar.currentValue === true)
            {
              //console.log($sVar, $specificFeedbackObj, $specificFeedbackObj.vars);
              $sContent = $specificFeedbackObj.vars[$sVar.name];
              if ($sContent)
              {
                $feedbackStr = $feedbackStr.concat('<br />', $sContent);
              }
            }
          });
          $feedbackStr = $feedbackStr.concat('</ul>');
          if ($specificFeedbackObj.showReplay)
          {
            $showReplay = true;
          }
        }
      }

      /*
      REMOVED per ARC
      if (this.scenarioReplay && $failed)
      {
        $failed = false;
        this.page.set('earnedPoints', this.page.get('maxPoints'));
      }*/
      //TODO:Interface.setInterfaceButtonState( [Interface.CAPTION_BTN], [Interface.ACHIEVEMENTS_BTN, Interface.MENU_BTN] );
      this.setupFeedback($feedbackStr, $showReplay, $failed);
    },

    setupFeedback: function($textStr, $showReplay, $failed)
    {
      $failed = ($failed === undefined) ? false : $failed;

      var $overlay = ($failed) ? this.overlayFailMC : this.overlayMC;
      //var $overlayBg = $overlay.bg_mc;
      //var $textY = 15;
      var $paddingY = 30;
      var $replayBtn;
      var $returnBtn = $overlay.find('[data-mc=return_mc]');
      if (!$failed)
        $returnBtn.one('click', _.bind(this.goNext, this));//this.radio.trigger('ui.button.pressed.next');)
      else
        $returnBtn.hide();

      this.$el.find('.overlay-container .overlay-title h1').html(this.page.collection.parent.get('title'));

      //$textStr = NLUtils.makeLists($textStr);
      //$overlay.text_mc.text_tf.autoSize = 'left';
      $overlay.find('[data-mc=text_tf]').html($textStr);

      //this.overlayMC.replay_mc.visible = $showReplay;
      if ($failed && $showReplay)
      {
        //$replayBtn = new Button($overlay.replay_mc);
        //$replayBtn.setup();
        $replayBtn = $overlay.find('[data-mc=replay_mc]');
        $replayBtn.one('click', $.proxy(this.replayScenarioHandler, this));

        $paddingY = 85;
      }

      //$overlayBg.height = Math.min(350, $overlay.text_mc.height + $paddingY);
      //$overlay.text_mc.y = $overlayBg.getRect($overlay).y + $textY;
      //$overlay.text_mc.text_tf.mouseWheelEnabled = false;

      //if ($overlay.text_mc.text_tf.height > 400)
      //{
        //_feedbackScroll = new NLScroll($overlay.text_mc, { maxH:($overlayBg.height - $paddingY), distance: 2 } );
        //_feedbackScroll = new NLScroll($overlay.text_mc.text_tf, { maxH:400 } );
        //$overlay.text_mc.addChild(_feedbackScroll);
      //}

      if ($replayBtn)
      {
        //$replayBtn.mc.y = Math.max(330, Math.min(558, $overlay.text_mc.getRect($overlay).bottom + 15));// $overlayBg.getRect($overlay).bottom - $replayBtn.mc.height - 10;
        //$replayBtn.mc.y = $overlay.text_mc.getRect($overlay).bottom;// $overlayBg.getRect($overlay).bottom - $replayBtn.mc.height - 10;
        this.showOverlay(false);
      }
      else
      {
        this.showOverlay();
      }
      this.radio.trigger('ui.update', {help: false, home: false});
    },

    /*finish: function()
    {
      console.log('finish scenario', this.scenarioReplay);
      if (this.scenarioReplay)
      {
        this.page.set('earnedPoints', this.page.get('maxPoints'));
        console.log('second finish, updating points', this.page.get('earnedPoints'));
      }

      BaseScreen.prototype.finish.apply(this, arguments);
    },*/

    goNext: function()
    {
      this.radio.trigger('ui.button.pressed.next');
    },

    replayScenarioHandler: function(evt)
    {
      //this.mc.dispatchEvent(new NLEvent(NLEvent.LOAD_PAGE, this._page));
      //console.log(this.page);
      this.resetAll();
      //Engine.module('Navigation').go(this.page.id);
      Engine.module('Navigation').go(this.page.collection.parent.id);
      //this.trigger('LOAD_MODULE_BY_ID', this.page.collection.id);
    },

    showOverlay: function($pass)
    {
      $pass = ($pass === undefined) ? true : $pass;

      if (this.overlayMC && $pass)
      {
        this.overlayMC.show();
      }
      else if (this.overlayFailMC && !$pass)
      {
        this.overlayFailMC.show();
      }
    },

    hideOverlay: function()
    {
      if (this.overlayMC)
      {
        this.overlayMC.hide();
      }
      if (this.overlayFailMC)
      {
        this.overlayFailMC.hide();
      }
    },

    onSkipClickHandler: function(evt, $btn)
    {
      console.warn('Skip handler');
      /*try {
        this.skipFeedback();
      }
      catch (e) {
        console.error('error skipping', e);
      }*/
      try {
        if (!this.skipFeedback())
        {
          if (this.scenario.activeDialog != null)
          {
            //console.log('skip dialog audio');
            this.scenario.activeDialog.onFeedbackComplete();
          }
        }
      }
      catch (err) {
        console.log('error skipping', err);
      }
      return false;
    },

    onInfoClickHandler: function(evt)
    {
      this.showInfoOverlay();
    },

    onSkipAudioHandler: function(evt)
    {
      /*try {
        this.skipFeedback();
      }
      catch (e) {
        console.error('error skipping', e);
      }*/
      try {
        if (!this.skipFeedback())
        {
          if (this.scenario.activeDialog != null)
          {
            //console.log('skip dialog audio');
            this.scenario.activeDialog.onFeedbackComplete();
          }
        }
      }
      catch (err) {
        console.log('error skipping', err);
      }
    },

    skipFeedback: function()
    {
      console.warn('skipFeedback', this.scenario, this.scenario.activeDialog, this.scenario.activeActivity);
      var media = Engine.module('Media');
      if (media && media.primaryChannel && !media.primaryChannel.isPlaying)
        return false;

      if (this.scenario.activeDialog != null)
      {
        //console.log('skip dialog audio');
        this.scenario.activeDialog.skipAudio();// .contentAudio.skip();
      }
      else if (this.activeActivity != null)
      {
        //console.log('skip activity audio', this.activeActivity);
        this.activeActivity.skipAudio();
      }
      return true;
    },

    killFeedback: function()
    {
      if (this.scenario.activeDialog !== null)
      {
        this.scenario.activeDialog.killAudio();// .contentAudio.skip();
      }
    },

    showFeedbackBlocker: function()
    {
      this.blockerMC.show();
    },

    hideFeedbackBlocker: function()
    {
      if (!this.forceBlocker && !this.feedbackActive)
      {
        this.blockerMC.hide();
      }
      this.hideAudioProgress();
    },

    hideAudioProgress: function()
    {
      var $audioMC = this.blockerMC.find('[data-mc=audio_mc]');
      if (this.blockerMC && $audioMC.length > 0 && !this.scenarioReplay)
      {
        $audioMC.hide();
        this.clearAudioCaption();
      }
    },

    showAudioProgress: function()
    {
      var $audioMC = this.blockerMC.find('[data-mc=audio_mc]');
      if (this.blockerMC && $audioMC.length > 0)
      {
        $audioMC.show();
        $audioMC.off('click').one('click', _.bind(this.showAudioCaption, this));
      }
      //this.skipFeedback();
    },

    clearAudioCaption: function()
    {
      var $capMC = this.blockerMC.find('[data-mc=audio_caption_wrapper]');
      $capMC.removeClass('active');
      $capMC.find('[data-mc=audio_caption_text]');
    },

    showAudioCaption: function()
    {
      console.log('show audio caption');
      var $capMC = this.blockerMC.find('[data-mc=audio_caption_wrapper]');
      $capMC.addClass('active');
      $capMC.find('[data-mc=audio_caption_text]');

      try {
        Engine.module('Media').primaryChannel.cleanup();
      }
      catch (err) {
        console.log('can not pause', err);
      }
      $capMC.find('[data-mc=audio_caption_skip]').off('click').one('click', _.bind(this.captionSkipHandler, this));
    },

    captionSkipHandler: function()
    {
      try {
        if (!this.skipFeedback())
        {
          if (this.scenario.activeDialog != null)
          {
            //console.log('skip dialog audio');
            this.scenario.activeDialog.onFeedbackComplete();
          }
        }
      }
      catch (err) {
        console.log('error skipping', err);
      }
    },

    blockerClickHandler: function(evt)
    {
      //console.log('blocker handler');
      evt.stopImmediatePropagation();
      evt.preventDefault();
      if (!this.scenarioReplay)
        this.showAudioProgress();
      return false;
    },

    onShowConversationHandler: function($convo)
    {
      // var $convo = evt.noggin;
      ////console.log('SHOW CONVO: ' + $convo);
      if ($convo)
      {
        this.showConversation($convo);
      }
      if ($convo === this.scenario.firstConversation && !this.hideHelp)
      {
        //this.infoBtn.enable();
        //this.radio.trigger('ui.update', {help: true});
      }
      else
      {
        //this.infoBtn.disable();
        //this.radio.trigger('ui.update', {help: false});
      }

    },

    updateBugtracker: function()
    {
      if (this.activeLocation)
      {
        Engine.module('Bugtracker').track(this.options.page.id + '_' + this.activeLocation.name, this.activeLocation.activityType);
        //BugTracker.track(this._page.name + '_' + this.activeLocation.name, this.activeLocation.activityType);
      }
      else
      {
        Engine.module('Bugtracker').track(this.options.page.id + '_' + this.activeConversation.name, 'chat_mapper');
        //BugTracker.track(this._page.name + '_' + this.activeConversation.name, 'chat_mapper');
      }
    },

    showConversation: function($convo)
    {
      //console.log('Showing conversation.');
      this.deactivateDialogRadial();

      if (this.activeConversation && $convo.id !== this.activeConversation.id)
      {
        this.lastConversation = this.activeConversation;
      }

      if (this.lastConversation)
      {
        this.showFeedbackBlocker();
        this.lastConversation.end();
        //Tweener.removeTweens(this.lastConversation.bg);
        //Tweener.addTween(this.lastConversation.bg, { alpha: 0, time: 1, onComplete: $.proxy(this.onConversationHideCompleteCallback, this), onCompleteParams:[this.lastConversation.bg] } );
        //this.lastConversation.bg.fadeOut();
        if (this.lastConversation.bg)
          this.lastConversation.bg.stop().animate({opacity: 0}, {complete: $.proxy(this.onConversationHideCompleteCallback, this, this.lastConversation), duration: 500});

        this.lastConversation = null;
      }
      //console.warn($convo, this.activeConversation);
      this.scenario.activeConversation = $convo;
      this.activeConversation = $convo;
      this.enableActiveConversation();
      Scenario.updateDisplay();
      ////console.log(this.bgContainer);
      ////console.log(this.activeConversation.bg);
      if (this.activeConversation.bg)
      {
        this.bgContainer.append(this.activeConversation.bg);
        this.activeConversation.bg.stop().animate({opacity: 1}, 500);
      }
      this.updateBugtracker();

      this.buildChart();
    },

    buildChart: function()
    {
      var __nodes = this.activeConversation.dialogArr;
      var __dataObj = {};
      //var __arr;
      //var __obj;
      var __nodeCount = 0;
      var __idArr = [];

      //addNode(__dataObj, __nodes[0]);

      __dataObj = addNode(__nodes[0]);

      function addNode (__node, __symLink)
      {
        __symLink = (__symLink === undefined) ? false : __symLink;

        ////console.log('adding node', __node);

        var __nObj = {};

        __nObj.nlID = __node.nlID;
        __nObj.name = __node.name || __node.nodeType;
        __nObj.symLink = __symLink ? 'True' : 'False';
        __nObj.isGroup = __node.isGroup ? 'True' : 'False';
        __nObj.color = __node.nodeColor;
        __nObj.description = __node.description;
        __nObj.dialogText = __node.dialogText || __node.menuText;
        __nObj.dType = __node.nodeType;
        __nObj.isQuestion = __node.isQuestion ? 'True' : 'False';
        __nObj.isFeedback = __node.isFeedback ? 'True' : 'False';
        __nObj.script = __node.script || 'N/A';
        __nObj.conditions = __node.conditionString || 'N/A';
        //alert(__node._actorID)
        if (__node.actorID)
          __nObj.actorName = Scenario.getActorByID(__node.actorID).name;
        else
          console.error('ScenarioMapper::addNode -> Error finding actor: ', __nObj.nlID, __node.actorID);

        __nodeCount++;
        ////console.log(__nObj);

        if (!__symLink && __node.linksArr.length > 0)
        {
          __idArr.push(__nObj.nlID);
          __nObj.children = addChildren(__node.linksArr);

        }
        return __nObj;
      }

      function addChildren (__arr)
      {
        ////console.log('adding children to node');
        var __cArr = [];
        for (var __key in __arr)
        {
          var __link = __arr[__key];
          var __dia = ScenarioDialog.getDialogByID(__link.destinationDialog().id);

          if (__dia)
          {
            var __index = $.inArray(__dia.nlID, __idArr);
            var __symLink = (__index !== -1);

            __cArr.push(addNode(__dia, __symLink));
          }
        }
        return __cArr;
      }

      /*for (var __key in __nodes)
      {
        __obj = __nodes[__key];
        __arr = [__obj.get_nlID(), ];
        __dataArr.push(__arr);
      }*/
      //alert($.genome.plugins.Chatmapper_tree);
      if (Engine.module('Cheats').settings.chatTree === true)
      {
        ChatmapperTree.newTree(__dataObj);
      }
    },

    onConversationHideCompleteCallback: function($convo)
    {
      this.hideFeedbackBlocker();
      if ($convo)
      {
        $convo.bgContainerMC.css('left', 0);
        Scenario.resetLookVars();

        //this.bgContainer.hide($mc);
        //this.bgContainer.detach($convo.bg);
        $convo.bg.detach();
      }
    },

    onShowDialogHandler: function($dialog)
    {
      //var $dialog = evt.noggin;
      //var $link;

      if ($dialog)
      {
        if (ChatmapperTree && ChatmapperTree.tree)
        {
          ChatmapperTree.updateByID($dialog.nlID);
        }

        this.clearChat();
        this.deactivateDialogRadial();
        switch ($dialog.nodeType)
        {
          case Scenario.NODE_TYPE_HOTSPOT:
            this.activateDialogHotspots($dialog);
            break;
          case Scenario.NODE_TYPE_RADIAL:
            this.activateDialogRadial($dialog);
            break;
          case Scenario.NODE_TYPE_CHAT:
            this.activateDialogChat($dialog);
            break;
          case Scenario.NODE_TYPE_ACTIVITY:
            this.activateDialogActivity($dialog);
            break;
        }
      }
      else
      {
        console.error('ScenarioMapper::onShowDialogHandler -> Unable to show Dialog');
      }
    },

    initialHotspotSetup: function()
    {
      var $convosObj = this.scenario.conversations;
      //var $convo;
      //var $dialog;
      //var $linkDialog;
      //var $link;
      var self = this;
      _.each($convosObj, function($convo) {
        _.each($convo.dialogArr, function($dialog) {
          if ($dialog.nodeType === Scenario.NODE_TYPE_HOTSPOT)
          {
            self.activateDialogHotspots($dialog, $convo);
          }
        });
        $convo.updateActiveHotspots();
      });
    },
    activateDialogHotspots: function($dialog, $convo)
    {
      $convo = ($convo === undefined) ? null : $convo;

      //var $link;
      var $hotDialog;
      var $stageMC;
      //var $btn;
      var $followDialog;
      //var $mcNameArr;
      //var $mcNameStr;
      var self = this;

      $convo = $convo || this.activeConversation;

      _.each($dialog.linksArr, function($link) {
        $hotDialog = $link.destinationDialog();
        //console.warn('hotspotdialog', $hotDialog, $hotDialog.mcName);
        if (!$hotDialog.mcName)
        {
          console.error('No name_mc specified for hotspot (convoID, dialogID): ' + $hotDialog.parentConvo.id + ', ' + $hotDialog.id);
          return;
        }
        ////console.log('HOTSPOTS: ', $convo, $convo.id, $convo.bg);
        $stageMC = ScenarioUtils.findAssetInContainer($hotDialog.mcName, $convo.bg);

        if ($stageMC)
        {
          if ($stageMC.data().dialog)
            return; // already setup

          $stageMC.show();
          $stageMC.data().dialog = $hotDialog;
          $hotDialog.stageMC = $stageMC;
          //$btn = new Button($stageMC);
          //$btn.setup();
          //$btn.useDefaults = false;
          $stageMC.on('click', $.proxy(self.onHotspotClickHandler, self, $hotDialog));

          $convo.addHotspot($stageMC);
        }
        else if ($hotDialog.mcName === 'follow')
        {
          $followDialog = $hotDialog;
        }
        else
        {
          console.error('Unable to map hotspot to stage: ' + $hotDialog.mcName);
        }
      });

      if ($convo === this.activeConversation)
      {
        $convo.updateActiveHotspots();
        Scenario.updateItemFrames();
        if ($followDialog) // auto follow hs
        {
          $convo.checkDialog($followDialog);
        }
      }
    },

    activateDialogRadial: function($dialog)
    {
      //console.error('activate dialog radial ', $dialog);
      this.deactivateDialogRadial();

      if (!this.lastClickMC)
        return false;

      //var $radMenu = new RadialMenu();
      var $radView = new RadialMenu({ className: $dialog.mcName });
      var $radMenu = $radView.$el;
      var $lastPos = {left: 0, top: 0};
      if (this.lastClickMC)
        $lastPos = this.lastClickMC.position();

      $radMenu.css({
        left: $lastPos.left,
        top: $lastPos.top
      });// this.radialContainer.mouseX;
      //$radMenu.y = this.lastClickMC.y;// this.radialContainer.mouseY;
      if (this.lastClickMC && this.lastClickMC.find('[data-mc=registration_mc]').length > 0)
      {
        var $regPos = this.lastClickMC.find('[data-mc=registration_mc]').position();
        $radMenu.css('left', '+=' + $regPos.left);
        $radMenu.css('top', '+=' +  $regPos.top);
      }

      ////console.log(this.radialContainer);
      this.radialContainer.append($radMenu);
      var $rightMenu = ($radMenu.position().left <= 550) ? true : false;
      //var $radClose = new Button($radMenu.hub_mc);
      //$radClose.setup();
      var self = this;
      _.delay(function() {
        $radMenu.find('[data-mc=hub_mc]').on('click', $.proxy(self.deactivateDialogRadial, self));
        self.$el.on('click', $.proxy(self.onNonRadialClickHandler, self));
      }, 250);

      var $radItem;
      //var $link;
      //var $btn;
      var $yPad = 0;

      _.each($dialog.linksArr, function($link) {
        $dialog = $link.destinationDialog();
        if (!$dialog.getAvailable() || !$dialog.menuText)
          return;

        $radView = new RadialItem();
        $radItem = $radView.$el;
        $radItem.data().dialog = $dialog;
        $radItem.css('top', $radMenu.find('[data-mc=itemHolder_mc]').height() + $yPad);
        //$btn = new Button($radItem);
        //$btn.text = $dialog.menuText;
        //$btn.setup();
        $radItem.find('[data-mc=text_tf]').html($dialog.menuText);
        $radItem.one('click', $.proxy(self.onRadialClickHandler, self, $dialog));
        $radMenu.find('[data-mc=itemHolder_mc]').append($radItem);

        if (!$rightMenu)
        {
          $radMenu.find('[data-mc=itemHolder_mc]').addClass('left-menu');
          /*$radItem.css('left', -$radItem.width());
          $radItem.find('[data-mc=text_tf]').css('left', 5);*/
        }

        $yPad = 2;
        if (!$dialog.getAvailable())
        {
          $radItem.addClass('disabled');//.disable();
        }
      });

      //$radMenu.hub_mc.mask_mc.graphics.beginFill(0);
      //$radMenu.hub_mc.mask_mc.graphics.drawRect( -200, -200, 400, 400);
      //$radMenu.hub_mc.mask_mc.graphics.drawCircle(0, 0, 50);
      //$radMenu.itemHolder_mc.mask = $radMenu.hub_mc.mask_mc;
      $radMenu.find('[data-mc=itemHolder_mc]').css('top', (this.lastClickMC.height() / 2) - $radMenu.find('[data-mc=itemHolder_mc]').height() / 2);
      this.showRadial($radMenu);
    },

    onNonRadialClickHandler: function(evt)
    {
      ////console.log('non-radial: ' + evt);
      this.deactivateDialogRadial();
      return false;
    },

    onRadialClickHandler: function($dialog, evt, $btn)
    {
      ////console.log('radial click', $dialog, evt, $btn);
      //var $dialog = $btn.mc.dialog;
      this.deactivateDialogRadial(evt);
      $dialog.activate();
    },

    deactivateDialogRadial: function(evt, $btn)
    {
      ////console.log(evt, $btn);
      evt = (evt === undefined) ? null : evt;
      $btn = ($btn === undefined) ? null : $btn;

      if (evt)
      {
        evt.stopImmediatePropagation();
      }

      this.$el.off('click');

      if (this.activeRadial)
      {
        this.hideRadial(this.activeRadial);
      }
    },

    showRadial: function($radial)
    {
      this.activeRadial = $radial;
      $radial.css('opacity', 0);
      $radial.animate({opacity: 1}, {duration: 250});
      return;
      /*$radial.rotation = 0;
      //Tweener.removeTweens($radial);
      $radial.stop();
      $radial.scaleX = 0.25;
      $radial.scaleY = 0.25;
      //Tweener.addTween($radial, { alpha:1, scaleX:1, scaleY:1, time: 0.5 } );
      $radial.animate({opacity: 1}, 500);

      if ($radial.x < 100)
      {
        if ($radial.y < 100)
        {
          $radial.rotation = 40;
        }
        else if ($radial.y > 550)
        {
          $radial.rotation = -40;
        }
      }
      else if ($radial.x > 913)
      {
        if ($radial.y < 100)
        {
          $radial.rotation = -40;
        }
        else if ($radial.y > 550)
        {
          $radial.rotation = 40;
        }
      }TODO:*/
    },

    hideRadial: function($radial)
    {
      //$radial.remove();
      $radial.animate({opacity: 0}, {duration: 250, complete: $.proxy(this.removeRadial, this, $radial)});
      return;
      /*$radial.mouseChildren = false;
      $radial.mouseEnabled = false;
      $radial.enabled = false;*/

      //Tweener.removeTweens($radial);
      //Tweener.addTween($radial, { time: 0.5, alpha: 0, scaleX:0.5, scaleY:0.5, onComplete: removeRadial, onCompleteParams: [$radial] } );
    },

    removeRadial: function($radial)
    {
      if ($radial)// && this.radialContainer.contains($radial))
      {
        //this.radialContainer.removeChild($radial);
        $radial.remove();
      }
    },

    onHotspotClickHandler: function($dialog, evt)
    {
      ////console.log('onhotspotclick', evt, $dialog.id, $dialog);
      evt.stopPropagation();
      //var $dialog = $(evt.currentTarget).data().dialog;
      if ($dialog)
      {
        this.lastClickMC = $(evt.currentTarget);
        $dialog.activate();
      }

      return false;
    },

    onHotspotOverHandler: function(evt)
    {
      // no action - overrides default
    },

    onHotspotOutHandler: function(evt)
    {
      // no action - overrides default
    },

    activateDialogChat: function($dialog)
    {
      ////console.log('Activate chat: ' + $dialog.linksArr);
      this.clearChat();
      this.deactivateDialogRadial();
      //this.showFeedbackBlocker();

      this.activeChat = $('<div>');//new Sprite();
      this.chatContainer = $dialog.parentConvo.chatContainerMC;
      this.chatContainer.append(this.activeChat);

      var $item;
      //var $btn;
      var $yPad = 0;

      var self = this;
      _.each($dialog.linksArr, function($link) {
        $dialog = $link.destinationDialog();
        if (!$dialog.getAvailable())
          return;

        var $chatView = new RadialItem();
        $item = $chatView.$el; // ChatItem
        $item.removeClass('radial-item').addClass('chat-item');
        $item.data().dialog = $dialog;
        $item.css('top', self.activeChat.height() + $yPad);
        self.activeChat.append($item);
        //$btn = new Button($item);
        $item.find('[data-mc=text_tf]').html($dialog.menuText);
        //$btn.setup();
        $item.on('click', $.proxy(self.onChatClickHandler, self, $dialog));
        $yPad = 10;
       /* if ($item.backing_mc)
        {
          $item.backing_mc.height = $item.text_tf.height + 20;
        }*/
        // if (!$dialog.getAvailable())
        // {
        //   $btn.disable();
        // }
      });

      this.showChat();
    },

    onChatClickHandler: function($dialog, evt, $btn)
    {
      //var $dialog = $btn.mc.dialog;
      this.hideFeedbackBlocker();
      this.lastClickMC = $(evt.currentTarget);
      this.clearChat();
      $dialog.activate();
    },

    clearChat: function()
    {
      if (this.activeChat && this.chatContainer)
      {
        this.activeChat.remove();
        this.activeChat.empty();
        // while (this.activeChat.numChildren > 0)
        // {
        //   var $chatItem = this.activeChat.getChildAt(0);
        //   var $btn = $chatItem.wrapper;
        //   $btn.destroy();
        //   this.activeChat.removeChild($chatItem);
        // }
      }
      this.activeChat = null;
      this.hideChat();
    },

    hideChat: function()
    {
      if (this.chatContainer)
      {
        this.chatContainer.visible = false;
      }
    },

    showChat: function()
    {
      if (this.chatContainer)
      {
        this.chatContainer.visible = true;
      }
    },

    disableActiveConversation: function()
    {
      if (!this.activeConversation)
        return;

      // this.activeConversation.bgContainerMC.mouseEnabled = false;
      // this.activeConversation.bgContainerMC.mouseChildren = false;

      // this.activeConversation.staticContainerMC.mouseEnabled = false;
      // this.activeConversation.staticContainerMC.mouseChildren = false;
    },

    enableActiveConversation: function()
    {
      if (!this.activeConversation)
        return;

      // this.activeConversation.bgContainerMC.mouseEnabled = true;
      // this.activeConversation.bgContainerMC.mouseChildren = true;

      // this.activeConversation.staticContainerMC.mouseEnabled = true;
      // this.activeConversation.staticContainerMC.mouseChildren = true;
    },

    activateDialogActivity: function($dialog)
    {
      //console.log('Activate Dialog Activity');
      this.clearActivity();
      this.killFeedback();
      var $location = Scenario.getLocationByName($dialog.description);

      if ($location)
      {
        this.disableActiveConversation();
        ScenarioLocation.resetPerformance();

        $location.on(Scenario.LOCATION_FATAL, $.proxy(this.onLocationFatalHandler, this, $location));
        $location.on(Scenario.LOCATION_READY, $.proxy(this.onLocationReadyHandler, this, $location));

        _.delay($.proxy($location.load, $location), 200);
        this.updateBugtracker();
      }
      else
      {
        console.error('Error finding activity location: ' + $dialog.description);
      }
    },

    onLocationFatalHandler: function($location)
    {
      $location.off(Scenario.LOCATION_FATAL);
      $location.off(Scenario.LOCATION_READY);

      this.onActivityReadyHandler();
    },

    onLocationReadyHandler: function($location)
    {
      //console.log('Location Ready', this.scenario, $location);
      if ($location)
      {
        this.activeLocation = $location;
        $location.off(Scenario.LOCATION_FATAL);
        $location.off(Scenario.LOCATION_READY);

        //var ActivityClass = getDefinitionByName('com.noggin.activities.' + $location.activityType);
        this.activeActivity = $location.swfContent;
        this.activeActivity.on(Scenario.ACTIVITY_COMPLETE, $.proxy(this.onActivityCompleteHandler, this));
        this.activeActivity.on(Scenario.UPDATE_ACTIVITY_LOADING, $.proxy(this.updateActivityLoader, this));

        if (this.activeActivity.isReady)
        {
          this.onActivityReadyHandler();
        }
        else
        {
          this.showActivityLoader();
          this.activeActivity.on(Scenario.ACTIVITY_READY, $.proxy(this.onActivityReadyHandler, this));
        }
        this.activeActivity.setup($location);
        this.activityHolder.show(this.activeActivity);
        this.checkActivitySkip();
        this.updateBugtracker();
      }
      else
      {
        console.error('Unknown location is ready');
      }
    },

    checkActivitySkip: function()
    {
      if (this.moduleReplay)
      {
        this.showActivitySkip();
        this.activitySkipBtn.off('click');
        this.activitySkipBtn.on('click', $.proxy(this.onSkipClickHandler, this));
      }
      else
      {
        this.hideActivitySkip();
      }
    },

    hideActivitySkip: function()
    {
      this.activitySkipBtn.hide();
    },

    showActivitySkip: function()
    {
      this.activitySkipBtn.show();
    },

    onActivityReadyHandler: function($activity)
    {
      //console.log('Activity Ready');
      this.activeActivity.off(Scenario.ACTIVITY_READY);
      this.activeActivity.off(Scenario.UPDATE_ACTIVITY_LOADING);

      if (this.activeLocation)
      {
        this.activeLocation.off(Scenario.LOCATION_FATAL);
        this.activeLocation.off(Scenario.LOCATION_READY);
      }

      this.activeActivity.begin();
      this.hideActivityLoader();
    },

    onActivityCompleteHandler: function(evt)
    {
      //console.log('Activity Complete');
      // if (CourseSettings.singleton.gAnalytics && ExternalInterface.available)
      // {
      //   ExternalInterface.call('GAActivityCompleted', this.activeLocation.name, this.activeLocation.performance, this._page.moduleAnalytics);
      //   console.warn('Event Analytics: ' + this.activeLocation.name + ' | ' + this.activeLocation.performance + ' | ' + this._page.moduleAnalytics);
      // }TODO: ganalytics
      this.clearActivity(this.activeActivity, this.activeLocation);
      this.activeActivity = null;
      this.activeLocation = null;

      ScenarioDialog.activeDialog.checkBranches();
      this.updateBugtracker();
    },

    clearActivity: function($activity, $location)
    {
      $activity = ($activity === undefined) ? this.activeActivity : $activity;
      $location = ($location === undefined) ? this.activeLocation : $location;

      this.hideActivitySkip();
      if ($activity)
      {
        $activity.off(Scenario.ACTIVITY_COMPLETE);
        //$activity.destroy();
        this.activityHolder.empty();//.removeChild($activity.asset);
      }

      if ($location)
      {
        $location.off(Scenario.LOCATION_FATAL);
        $location.off(Scenario.LOCATION_READY);
        $location.resetLocation();
      }

      this.enableActiveConversation();
    },

    showActivity: function()
    {

    },

    hideActivity: function()
    {

    },

    onScenarioCompleteHandler: function(evt)
    {
      this.finishScenario();
    },

    calculatePoints: function()
    {
      var $maxPoints = Scenario.getVariableValueByName('maxPoints') || 100;
      var $curPoints = Scenario.getVariableValueByName('points');
      //var $perc = $curPoints / $maxPoints;
      ////console.log(this.model);
      this.page.set('maxPoints', $maxPoints);
      this.page.set('earnedPoints', $curPoints);
    },

    finishScenario: function()
    {
      //console.error('finishScenario');
      this.calculatePoints();
      this.showFinishOverlay();
      this.radio.trigger('ui.update', {help: false, home: false});
      this.finish();
    },

    resetAll: function()
    {
      if (this.scenario)
      {
        this.scenario.off(Scenario.SCENARIO_READY);
        this.scenario.off(Scenario.SCENARIO_COMPLETE);

        this.scenario.off(Scenario.SHOW_CONVERSATION);
        this.scenario.off(Scenario.SHOW_DIALOG);

        this.scenario.off(Scenario.FEEDBACK_STARTED);
        this.scenario.off(Scenario.FEEDBACK_COMPLETE);
        this.scenario.off(Scenario.UPDATE_FEEDBACK_PROGRESS);

        this.scenario.off(Scenario.SHOW_BLOCKER);
        this.scenario.off(Scenario.HIDE_BLOCKER);

        this.scenario.off(Scenario.UPDATE_POINTS);

        //.off(Scenario.SKIP_MAPPER_AUDIO, this.onSkipAudioHandler);
        this.scenario.destroy();
      }

      this.$el.off('click');

      this.lastConversation = null;
      this.activeConversation = null;

      if (this.blockerMC)
      {
        this.blockerMC.off('click');
      }

      this.$el.empty();

      /*if (_ambientSC)
      {
        _ambientSC.stop();
      }*/
    },

    customDestroy: function()
    {
      this.radio.off('scenario.overlay.closing');
      $('#genome .genome-viewport').removeClass('hide-captions');
      this.resetAll();
    }
    /*****************************************************************************************************************///}

  });

  return ScenarioMapper;

});

/*****************************************************************************************************************///}

    /////////////////////
    // PUBLIC METHODS //{
    /////////////////////

    /*destroy: function()
    {
      this.scenario.removeEventListener(Scenario.SCENARIO_READY, this.onScenarioReadyHandler);
      this.scenario.removeEventListener(Scenario.SCENARIO_COMPLETE, this.onScenarioCompleteHandler);

      this.scenario.removeEventListener(Scenario.SHOW_CONVERSATION, this.onShowConversationHandler);
      this.scenario.removeEventListener(Scenario.SHOW_DIALOG, this.onShowDialogHandler);

      this.scenario.removeEventListener(Scenario.FEEDBACK_STARTED, this.onFeedbackStartHandler);
      this.scenario.removeEventListener(Scenario.FEEDBACK_COMPLETE, this.onFeedbackCompleteHandler);
      this.scenario.removeEventListener(Scenario.UPDATE_FEEDBACK_PROGRESS, this.onFeedbackProgressHandler);

      this.scenario.removeEventListener(Scenario.SHOW_BLOCKER, this.onShowBlockerHandler);
      this.scenario.removeEventListener(Scenario.HIDE_BLOCKER, this.onHideBlockerHandler);

      this.scenario.removeEventListener(Scenario.UPDATE_POINTS, this.onUpdatePointsHandler);

      this._stage.removeEventListener(Scenario.SKIP_MAPPER_AUDIO, this.onSkipAudioHandler);

      this.mc.removeEventListener(MouseEvent.CLICK, onNonRadialClickHandler);

      this.scenario.destroy();

      this.lastConversation = null;
      this.activeConversation = null;

      if (this.blockerMC)
      {
        this.blockerMC.removeEventListener(MouseEvent.CLICK, blockerClickHandler);
      }

      if (_ambientSC)
      {
        _ambientSC.stop();
      }

      super.destroy();
    }*/
;
